<template>
  <div class="hidden justify-between sm:flex">
    <div class="ml-auto flex gap-2">
      <Button
        title="Download Geofence Report"
        size="sm"
        variant="tertiary"
        icon="ArrowDownTrayIcon"
        class="w-1/2 sm:w-auto"
        @click="download"
      ></Button>
    </div>
  </div>
</template>
<script setup lang="ts">
import { useToast } from 'vue-toastification';
import { useRoute } from 'vue-router';
import { useInsights } from '@/composables/useInsights';
import * as events from '@/events';

const toast = useToast();
const route = useRoute();
const { downloadPdfReport } = useInsights();

const download = async () => {
  events.trigger(events.names.GEOFENCE_REPORT_DOWNLOADED);

  const reportId = route.params.id;
  
  if (!reportId) {
    toast.error('No report selected');
    return;
  }

  const success = await downloadPdfReport(reportId);
  
  if (success) {
    toast.success('PDF report downloaded successfully');
  } else {
    toast.error('Failed to download PDF report');
  }
};
</script>
